<template>
  <page-form-cmp
    v-animation:bottom.delay
    action="reviews"
    :form-config="form"
    :submit-label="button"
    :agreements="[PERSONAL_DATA_AGREEMENT]"
    class="_reviews"
  >
    <template #profilePublicationAgreement="{ field, input }">
      <FormField :field="field">
        <ProfilePublicationAgreement :value="field.value" :error="field.error" @input="input"></ProfilePublicationAgreement>
      </FormField>
    </template>
  </page-form-cmp>
</template>

<script>
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import FormField from '@shared/ui/public/forms/components/FormField.vue'
import ProfilePublicationAgreement from '@shared/ui/public/forms/fields/ProfilePublicationAgreement.vue'
import { LEGACY_FORM_VARIANTS } from '@shared/const/form/form.data'
import { PERSONAL_DATA_AGREEMENT } from '@shared/const/form/form.field'

export default {
  name: 'form-reviews',
  components: {
    FormField,
    ProfilePublicationAgreement,
    'page-form-cmp': PageForm,
  },
  props: {
    button: String,
    formInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    PERSONAL_DATA_AGREEMENT() {
      return PERSONAL_DATA_AGREEMENT
    },
  },
  data() {
    return {
      form: {
        title: this.$root.staticText.reviewTitle,
        type: LEGACY_FORM_VARIANTS.DEFAULT_BUILDER,
        fields: [
          {
            type: 'form_field',
            content: {
              id: 'name',
              typeField: 1,
              title: this.$root.staticText.forms.name,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderName,
              defaultValue: this.formInfo?.fields.name.defaultValue || '',
              addParams: [{ code: 'readonlyIfPrefilled', value: true }],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'surname',
              typeField: 1,
              title: this.$root.staticText.forms.surname,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderSurname,
              defaultValue: this.formInfo?.fields.surname.defaultValue || '',
              addParams: [{ code: 'readonlyIfPrefilled', value: true }],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'company',
              typeField: 1,
              title: this.$root.staticText.forms.company,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderCompany,
              defaultValue: this.formInfo?.fields.company.defaultValue || '',
              addParams: [{ code: 'readonlyIfPrefilled', value: true }],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'city',
              typeField: 1,
              title: this.$root.staticText.forms.city,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderCity,
              defaultValue: this.formInfo?.fields.city.defaultValue || '',
              addParams: [{ code: 'readonlyIfPrefilled', value: true }],
            },
          },

          {
            type: 'form_field',
            content: {
              id: 'radioLike',
              typeField: 14,
              title: this.$root.staticText.forms.radioLike,
              requiredField: 0,
              description: null,
              hintField: null,
              list: [
                {
                  id: 1,
                  label: this.$root.staticText.forms.yes,
                },
                {
                  id: 0,
                  label: this.$root.staticText.forms.no,
                },
              ],
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'radioPost',
              typeField: 14,
              title: this.$root.staticText.forms.radioPost,
              requiredField: 0,
              description: null,
              hintField: null,
              list: [
                {
                  id: 1,
                  label: this.$root.staticText.forms.yes,
                },
                {
                  id: 0,
                  label: this.$root.staticText.forms.no,
                },
              ],
            },
          },

          {
            type: 'form_field',
            content: {
              id: 'comment',
              typeField: 2,
              title: this.$root.staticText.forms.review,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderReview,
            },
          },
        ],
      },
    }
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/forms/form-reviews.vue